<div class="row" style="padding: 0px 15px;">
    <div class="grid-agg">
        <ag-grid-angular #agGrid [ngStyle]="{'height': dynamicHeight + 'px',
            'width':'100%' , 'font-family':'Roboto'}" id="myGrid" class="ag-theme-balham"
            [pagination]="true" [columnDefs]="columnDefs" [rowData]="alarmRoutes" [gridOptions]="gridOptions"
            [defaultColDef]="defaultColDef"  [paginationPageSize]="paginationPageSize"
            (gridReady)="onGridReady($event)" [icons]="icons">
        </ag-grid-angular>

        <div class="custom-pagination" *ngIf="totalRecords > 0">
                <div class="left">
                    <span class="records-per-page">
                        <span>Records/Page : </span>
                        <select [(ngModel)]="rpPage" (change)="rppChanged($event)">
                            <option *ngFor="let size of pgDropDown" [value]="size.value">{{ size.value }}</option>
                        </select>
                    </span>
                </div>
                <div class="right">
                    <span class="viewing-records">
                    <span class="w-600">{{sRecord}}</span> to <span class="w-600">{{eRecord}}</span> of <span class="w-600">{{totalRecords}}</span>
                    <button (click)="goToFirstPage()" [disabled]="getCurrentPage() === true"><i class="fa-solid fa-backward-fast"
                        [ngStyle]="getCurrentPage() === true ? {'color': 'gray'} : {'color': '#1394f6'}"></i></button>
                    <button (click)="goToPreviousPage()" [disabled]="getCurrentPage() === true"><i class="fa-solid fa-backward-step"
                        [ngStyle]="getCurrentPage() === true ? {'color': 'gray'} : {'color': '#1394f6'}"></i></button>
                    <span>Page <span class="w-600">{{cPage}}</span> of <span class="w-600">{{tPage}}</span></span>
                    <button (click)="goToNextPage()" [disabled]="isLastPage() === true"><i class="fa-solid fa-forward-step"
                        [ngStyle]="isLastPage() === true ? {'color': 'gray'} : {'color': '#1394f6'}"></i></button>
                    <button (click)="goToLastPage()" [disabled]="isLastPage() === true"><i class="fa-solid fa-forward-fast"
                        [ngStyle]="isLastPage() === true ? {'color': 'gray'} : {'color': '#1394f6'}"></i></button>
                    </span>
                </div>
            </div>
    </div>
</div>
<div class="row">
    <div *ngIf="this.exportRoutesButtonClicked" class="row">
        <div class="col-md-3"></div>
        <div class="col-md-6">
            <div *ngIf="this.exportMessage.length > 0" class="alert alert-success" role="alert">
                <mat-icon>thumb_up</mat-icon> &nbsp;
                <label style="vertical-align: text-bottom; margin-bottom: 0rem;">{{exportMessage}}</label>
            </div>
        </div>
        <div class="col-md-3"></div>
    </div>
</div>